module.exports = __webpack_public_path__ + "img/0Q3A5108-23_P_L_Black_MockedUp.9e7c4a45.jpg";